import React from "react";
//#region types
import { KeyValue } from "models/utilTypes/keyValue";
import { TranslationKeys } from "translations";
import { ReceiptPaymentMethodDetailsProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { DetailsTableView } from "components/common";
import { useReceiptPaymentMethodService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const PaymentMethodDetails: React.FC<ReceiptPaymentMethodDetailsProps> = (props) => {
  const receiptPaymentMethodService = useReceiptPaymentMethodService();
  const { paymentMethod } = props;

  const getStateText = () => {
    return paymentMethod?.isActive === undefined
      ? "-"
      : paymentMethod.isActive
      ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Active)
      : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.InActive);
  };

  const getDetailsList = () => {
    const detailsList = [
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Type),
        receiptPaymentMethodService.getTypeText(paymentMethod?.type)
      ),
      new KeyValue(LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Active), getStateText()),
    ];
    return detailsList;
  };

  return <DetailsTableView detailsList={getDetailsList()}></DetailsTableView>;
};

export default PaymentMethodDetails;
